
import React from "react";
import { Container, Group, Paper, Text } from "@mantine/core";
import { Link,  } from "react-router-dom";
import { IconSettings, IconShieldHalf, IconUserCog, IconUsersGroup, IconCalendarEvent, IconKey } from "@tabler/icons-react";
import {IconSitemap, IconUsers, IconShield,  IconClockEdit} from "@tabler/icons-react";
import {Route, Routes} from "react-router-dom";
import FranchiseView from "./FranchiseView";
import FranchiseManagement from "./FranchiseManagement";
import FranchiseEdit from "./FranchiseEdit";
import FranchiseCreate from "./FranchiseCreate";
import UserManagement from "./UserManagement";
import UserEdit from "./UserEdit";
import SystemSettingsRoutes from "./SystemSettings/SystemSettingsHome";
import TeamManagement from "./TeamManagement";
import TeamEdit from "./TeamEdit";
import TeamCreate from "./TeamCreate";
import {HasAction} from "components/Auth/HasAction";
import {useActions} from "context/ActionsContext";
import DashboardCards from "components/Dashboard/DashboardCard";
import DashboardHeader from "components/Dashboard/DashboardHeader";
import SessionManagement from "./SessionManagement";
import SeasonManagement from "./SeasonManagement";
import SeasonCreate from "./SeasonCreate";
import SeasonEdit from "./SeasonEdit";
import RoleManagement from "./RoleManagement";
import RoleCreate from "./RoleCreate";
import RoleEdit from "./RoleEdit";
import {ADMIN_HUB_ACTIONS, ADMIN_HUB_CARD_ACTIONS} from "lib/hubAccess";


/**
 * Since we treat each up as a sub app within the main website, this will
 * provide the customized routing that will be nested under the admin hub,
 * allowing it to function isolated from the rest of the app.
 */
export default function AdminHub() {
    return (
      <HasAction action={[...ADMIN_HUB_ACTIONS]}>
        <Routes>
          <Route path="/" element={<AdminDashboard/>}/>
          {/* Franchise routes - specific routes before parameterized */}
          <Route path="/franchises" element={<FranchiseManagement/>}/>
          <Route path="/franchises/create" element={<FranchiseCreate/>}/>
          <Route path="/franchises/:franchiseId" element={<FranchiseView/>}/>
          <Route path="/franchises/:franchiseId/edit" element={<FranchiseEdit/>}/>
          {/* Team routes */}
          <Route path="/teams" element={<TeamManagement/>}/>
          <Route path="/teams/create" element={<TeamCreate/>}/>
          <Route path="/teams/:teamId" element={<TeamEdit/>}/>
          {/* User routes */}
          <Route path="/users" element={<UserManagement/>}/>
          <Route path="/users/:userId" element={<UserEdit/>}/>
          {/* Season routes */}
          <Route path="/seasons" element={<SeasonManagement/>}/>
          <Route path="/seasons/create" element={<SeasonCreate/>}/>
          <Route path="/seasons/:seasonId" element={<SeasonEdit/>}/>
          {/* Role routes */}
          <Route path="/roles" element={<RoleManagement/>}/>
          <Route path="/roles/create" element={<RoleCreate/>}/>
          <Route path="/roles/:roleId" element={<RoleEdit/>}/>
          {/* Other admin routes */}
          <Route path="/system-settings/*" element={<SystemSettingsRoutes/>}/>
          <Route path="/sessions" element={<SessionManagement/>}/>
        </Routes>
      </HasAction>
    );
}

function AdminDashboard(){
  const { hasAnyAction } = useActions();

  // Define all possible dashboard cards with their required actions
  const allElements = [
    {
      label: "User Management",
      description: "Manage users",
      icon: IconUsers,
      color: "violet",
      path: "users",
      actions: ADMIN_HUB_CARD_ACTIONS.userManagement
    },
    {
      label: "Franchise Management",
      description: "View and add franchises",
      icon: IconSitemap,
      color: "green",
      path: "franchises",
      actions: ADMIN_HUB_CARD_ACTIONS.franchiseManagement
    },
    {
      label: "Team Management",
      description: "Add and edit teams and roles",
      icon: IconShield,
      color: "teal",
      path: "teams",
      actions: ADMIN_HUB_CARD_ACTIONS.teamManagement
    },
    {
      label: "Season Management",
      description: "Manage competitive seasons",
      icon: IconCalendarEvent,
      color: "cyan",
      path: "seasons",
      actions: ADMIN_HUB_CARD_ACTIONS.seasonManagement
    },
    {
      label: "Role Management",
      description: "Manage roles and permissions",
      icon: IconKey,
      color: "grape",
      path: "roles",
      actions: ADMIN_HUB_CARD_ACTIONS.roleManagement
    },
    {
      label: "System Settings",
      description: "Configure platform settings",
      icon: IconSettings,
      color: "orange",
      path: "system-settings",
      actions: ADMIN_HUB_CARD_ACTIONS.settings
    },
    {
      label: "Session Management",
      description: "View or revoke user sessions",
      icon: IconClockEdit,
      color: "red",
      path: "sessions",
      actions: ADMIN_HUB_CARD_ACTIONS.sessions
    },
  ];

  // Filter cards to only show those the user has permissions for
  const elements = allElements.filter(el => hasAnyAction(el.actions));

  return (
    <div>
      <DashboardHeader
        title="Admin Hub"
        subtitle="Manage users, franchises, and settings"
      />
      <DashboardCards elements={elements} />
    </div>
  );
}
